<template>
  <div class="setting-page tongxin-layout">
    <h1 class="title-with-underline">資料設定</h1>

    <!-- 按鈕區 -->
    <div class="setting-buttons">
      <b-button
        block
        class="btn-rounded"
        :variant="selectedAction === 'switchClinic' ? 'primary' : 'outline-secondary'"
        @click="selectedAction = 'switchClinic'"
      >
        切換院所
      </b-button>

      <b-button
        block
        class="btn-rounded"
        :class="{ disabled: !hasRegistered }"
        :variant="selectedAction === 'familyList' ? 'primary' : 'outline-secondary'"
        @click="selectedAction = hasRegistered ? 'familyList' : selectedAction"
      >
        編輯家庭成員資料
      </b-button>

      <b-button
        block
        class="btn-rounded"
        :class="{ disabled: !hasRegistered }"
        :variant="selectedAction === 'rebindPhone' ? 'primary' : 'outline-secondary'"
        @click="selectedAction = hasRegistered ? 'rebindPhone' : selectedAction"
      >
        重新綁定手機
      </b-button>
    </div>

    <!-- 底部導航 -->
    <div class="setting-nav">
      <TongxinNavigation
        :canProceed="selectedAction !== null"
        :backButtonIsVisible="true"
        :nextButtonIsVisible="true"
        textForNextStep="下一步"
        @back="handleBack"
        @next="handleNext"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TongxinNavigation from '@/components/web/proj/tongxin/layout/TongxinNavigation.vue'
import Customer from '@/models/Customer.model'
import stepController from '@/mixins/web/tongxin/stepController'

export default {
  name: 'TongxinSetting',
  components: {
    TongxinNavigation,
  },
  data() {
    return {
      selectedAction: 'switchClinic',
    }
  },
  computed: {
    ...mapState('liffAuth', ['user']),
    hasRegistered() {
      return new Customer(this.user).hasRegistered
    },
  },
  methods: {
    handleBack() {
      stepController.methods.goToLineOfficialAccount.call(this)
    },
    handleNext() {
      if (this.selectedAction === 'familyList') {
        this.$router.push({ name: 'TongxinFamilyList', query: this.$route.query })
      }
      if (this.selectedAction === 'switchClinic') {
        this.$router.push({ name: 'TongxinCresclabMenu', query: this.$route.query })
      }
      if (this.selectedAction === 'rebindPhone') {
        this.$router.push({ name: 'TongxinUnbind', query: this.$route.query })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.setting-page {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;

  .setting-buttons {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 32px;
  }

  .setting-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
  }

  .btn {
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>
